import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastContainerComponent } from './app/shared/components/toasts/toast-container/toast-container.component';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterModule, ToastContainerComponent],
	template: `
		<app-toast-container />
		<router-outlet></router-outlet>
	`
})
export class AppComponent {}
